// 매출 현황 조회 조건 ↔ URL (2026-10-16)
//
// ?mode=year&year=2026 · ?mode=month&month=2026-10 · ?mode=range&from=&to= + &status=all|valid|active|done|canceled
// mode가 없거나 잘못되면 연간(올해), status가 없거나 잘못되면 취소 제외(2026-10-19 — PG 대조는 전체 탭).
// &category=all|hundred|goods|books(분류 탭, 2026-10-30) — 없거나 잘못되면 전체.
const pad = (n) => String(n).padStart(2, "0");

export const MODES = ["year", "month", "range"];
export const STATUS_TABS = [
  ["all", "전체"],
  ["valid", "취소 제외"],
  ["active", "진행 중"],
  ["done", "완료"],
  ["canceled", "취소"],
];
const STATUS_KEYS = STATUS_TABS.map(([key]) => key);

export const DEFAULT_STATUS = "valid";
export const statusLabel = (status) => (STATUS_TABS.find(([key]) => key === status) || STATUS_TABS[0])[1];

// 분류 탭 — 키 = 서버 RentalProduct.Category(sales.CATEGORY_TABS). 미분류는 전체에만 들어간다.
export const CATEGORY_TABS = [
  ["all", "전체"],
  ["hundred", "백일상"],
  ["goods", "육아용품"],
  ["books", "도서(전집)"],
];
const CATEGORY_KEYS = CATEGORY_TABS.map(([key]) => key);
export const DEFAULT_CATEGORY = "all";
export const categoryLabel = (category) =>
  (CATEGORY_TABS.find(([key]) => key === category) || CATEGORY_TABS[0])[1];

/** URL(URLSearchParams) → 처음 조회 조건. today는 시험용(기본 지금). */
export function readFilters(searchParams, today = new Date()) {
  const thisMonth = `${today.getFullYear()}-${pad(today.getMonth() + 1)}`;
  const get = (key, fallback) => searchParams.get(key) || fallback;
  return {
    mode: MODES.includes(searchParams.get("mode")) ? searchParams.get("mode") : "year",
    year: get("year", String(today.getFullYear())),
    month: get("month", thisMonth),
    from: get("from", `${thisMonth}-01`),
    to: get("to", `${thisMonth}-${pad(today.getDate())}`),
    status: STATUS_KEYS.includes(searchParams.get("status")) ? searchParams.get("status") : DEFAULT_STATUS,
    category: CATEGORY_KEYS.includes(searchParams.get("category")) ? searchParams.get("category") : DEFAULT_CATEGORY,
  };
}

/** 조회 조건 → URL·API 파라미터(기간 쪽). status는 따로 붙인다. */
export function periodParams({ mode, year, month, from, to }) {
  if (mode === "year") return { year };
  if (mode === "month") return { month };
  return { from, to };
}
